var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo } from 'react';
import { capitalize, CardActionArea } from '@material-ui/core';
import { mdiFlask, mdiHelpCircle, mdiLaunch, mdiNotebookCheckOutline } from '@mdi/js';
import { Icon } from '@mdi/react';
import plural from 'pluralize';
import { IconSize } from '../../../..';
import { AdeptCard, AdeptCardContent } from '../../../Structure';
import { LaunchIcon } from '../VirtualLabViewer/lab.styles';
import { LinkType } from './types';
export const LinkLauncher = (_a) => {
    var _b, _c;
    var { link, onClick } = _a, others = __rest(_a, ["link", "onClick"]);
    const linkIconPath = useMemo(() => {
        if (link.linkType === LinkType.LAB)
            return mdiFlask;
        if (link.linkType === LinkType.EXAM)
            return mdiNotebookCheckOutline;
        return mdiHelpCircle;
    }, [link.linkType]);
    return (React.createElement(AdeptCard, Object.assign({}, others),
        React.createElement(CardActionArea, { onClick: onClick ? onClick : () => { }, disableRipple: true },
            React.createElement(AdeptCardContent, { title: link.text, contentImageComponent: React.createElement(Icon, { path: linkIconPath, title: `${link.linkType} link Icon`, size: IconSize.ExtraLarge }), secondaryInfo: [
                    onClick
                        ? `${plural(capitalize((_b = link.linkType) !== null && _b !== void 0 ? _b : 'lab'))} by ${capitalize((_c = link.provider) !== null && _c !== void 0 ? _c : 'skillable')}`
                        : `Support for launching ${plural(link.linkType)} coming soon.`
                ], lowerRightComponent: React.createElement(LaunchIcon, { "$disabled": !!onClick, path: mdiLaunch, size: IconSize.Medium }) }))));
};
//# sourceMappingURL=Launcher.js.map